/**
 * Set the flag that indicates that the app is authenticating the user.
 *
 * @param {Object} state
 * @param {Boolean} loading
 */
function setLoadingAuthentication(state, loading) {
  state.loadingAuthentication = loading
}


export default {
  setLoadingAuthentication
}
